// MCP: as chaves de API que autenticam softwares externos no endpoint /mcp do
// back (Claude, Zapier e qualquer cliente que fale o Model Context Protocol).
// Espelha a feature `mcp` do back; as rotas /v1/mcp/keys exigem
// director/manager e o back rejeita o resto com 403.
//
// POR QUE não mora em ./crm.js, que também é "integração com software externo":
// não há um tipo, uma rota nem uma credencial em comum. O CRM empurra lead para
// dentro por webhook autenticado por chave de INGESTÃO, e o que se configura lá
// é funil e etapa; aqui um agente LÊ o Disk agindo COMO um membro (a chave
// herda o papel do `userId`). Junto, o arquivo teria dois vocabulários sem
// nenhuma frase que os ligue.
import { api, toApiError } from "./client.js";

export interface McpKey {
  id: string;
  name: string;
  // Membro que a chave "age como" no MCP (herda o papel dele).
  userId: string;
  // Prefixo público exibível (o segredo completo só aparece na criação).
  keyPrefix: string;
  lastUsedAt: string | null;
  expiresAt: string | null;
  revokedAt: string | null;
  createdBy: string;
  createdAt: string;
}

// GET /v1/mcp/keys — lista as chaves da org (metadados, sem segredo).
export async function getMcpKeys(): Promise<McpKey[]> {
  const { data, error } = await api<{ keys: McpKey[] }>("/v1/mcp/keys");
  if (error) throw toApiError("GET /v1/mcp/keys", error);
  return data.keys;
}

// POST /v1/mcp/keys — cria uma chave. `key` (o segredo) só vem AQUI, uma vez.
export async function createMcpKey(input: {
  name: string;
  userId?: string;
  expiresAt?: string;
}): Promise<McpKey & { key: string }> {
  const { data, error } = await api<McpKey & { key: string }>("/v1/mcp/keys", {
    method: "POST",
    body: input,
  });
  if (error) throw toApiError("POST /v1/mcp/keys", error);
  return data;
}

// DELETE /v1/mcp/keys/:id — revoga (soft) a chave.
export async function revokeMcpKey(id: string): Promise<void> {
  const { error } = await api(`/v1/mcp/keys/${id}`, { method: "DELETE" });
  if (error) throw toApiError(`DELETE /v1/mcp/keys/${id}`, error);
}
